import { createBrowserHistory, History } from 'history';
import { BASE_URL } from '../auth';

const history: History = createBrowserHistory({ basename: BASE_URL });

export default history;
